export const applyOfferPlaceholders = (value = '', context = {}) => {
  const candidateName = String(context.candidateName || 'Candidate').trim();
  const replacements = {
    candidate_name: candidateName,
    candidate_first_name: candidateName.split(/\s+/)[0],
    job_title: context.jobTitle || 'the role',
    company_name: context.companyName || 'our team',
    sequence: context.sequence || ''
  };
  return String(value || '').replace(/\{\{\s*([a-zA-Z_]+)\s*\}\}/g, (match, key) => (
    replacements[key] !== undefined ? replacements[key] : match
  ));
};

// Save recipient names as tokens so the next offer uses its own recipient.
export const tokenizeOfferRecipient = (value = '', candidateName = '') => {
  const name = String(candidateName || '').trim();
  if (!name || name === 'Candidate') return String(value || '');
  const firstName = name.split(/\s+/)[0];
  const names = [...new Set([name, firstName])];
  const escape = text => text.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = new RegExp(`(?<![\\p{L}\\p{N}_])(${names.map(escape).join('|')})(?![\\p{L}\\p{N}_])`, 'gu');
  return String(value || '').split(/(<[^>]+>|\{\{[^}]+\}\})/g).map(part => (
    part.startsWith('<') || part.startsWith('{{') ? part : part.replace(pattern, match => (
      match === name ? '{{candidate_name}}' : '{{candidate_first_name}}'
    ))
  )).join('');
};

// Older saved templates contain a literal greeting from the original offer.
export const normalizeOfferTemplateGreeting = (html = '') => String(html || '').replace(
  /^(\s*<p>\s*)(Hi|مرحبًا)\s+([^<,،{}]+)[,،](\s*<\/p>)/u,
  (_, start, greeting, name, end) => `${start}${greeting} {{candidate_first_name}}${greeting === 'Hi' ? ',' : '،'}${end}`
);
